<template>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-else>
        <v-row>
            <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                <div class="title_page ma-3">
                    <h4 class="breadcrumb_title_page">คลังสินค้าทุกสาขา</h4>
                    <v-breadcrumbs :items="sub_menu">
                        <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12 pt-0">
                <v-card elevation="4" style="border-radius: 15px;">
                    <v-card-text>
                        <div class="pa-4">
                            <v-form ref="#">
                                <v-row>
                                    <!-- ค้นหาล็อต -->
                                    <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                        <div class="d-flex">
                                            <div class="title_form_main">
                                                <div class="logo_timeline">
                                                    <img src="@/assets/arin_assets/box.png">
                                                </div>
                                            </div>
                                            <div class="header-content py-1 pl-5 pr-5 text-center">
                                                <div class="content-font">ค้นหาสินค้า</div>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="11" lg="11" xl="11" cols="12">
                                        <v-form-group>
                                            <label class="label_form_text">
                                                ชื่อสินค้า <span class="required--text">*</span>
                                            </label>
                                            <v-autocomplete class="input-radius" v-model="product_id" @change="addItem"
                                                :items="product_list" item-value="product_code" item-text="name"
                                                placeholder="ค้นหาสินค้า..." single-line solo ref="product_list"
                                                :search-input.sync="search" outlined dense :filter="filterProduct"
                                                hide-no-data>
                                                <template slot="selection" slot-scope="{ item }">
                                                    {{ item.name }}
                                                </template>
                                                <template slot="item" slot-scope="{ item }">
                                                    <v-list-tile-content>
                                                        <p class="fullName">{{ item.name }}</p>
                                                    </v-list-tile-content>
                                                </template>
                                            </v-autocomplete>
                                        </v-form-group>

                                    </v-col>
                                    <v-col class="mt-2" xs="12" sm="12" md="1" lg="1" xl="1" cols="12">
                                        <div @click="showBranch()" class="title_page ma-3"
                                            style="justify-content:center;">
                                            <v-btn type="button" class="btn_add_data" elevation="4" large>ค้นหา</v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" class="mb-10">
                <Transition name="slide-fade">
                    <v-card v-if="show" elevation="4" style="border-radius: 15px;">
                        <v-card-text>
                            <div class="pa-4">
                                <v-form ref="#">
                                    <v-row>
                                        <v-col cols="12" class="mb-2">
                                            <div
                                                class="d-flex align-center justify-space-between flex-wrap"
                                                style="gap: 12px"
                                            >
                                                <div class="content-header-title mb-0">ข้อมูลสินค้า</div>
                                                <v-btn color="success" @click="exportToExcel">
                                                    <v-icon left>mdi-microsoft-excel</v-icon>
                                                    Excel
                                                </v-btn>
                                            </div>
                                        </v-col>

                                        <!-- บรรทัดที่สอง: ข้อมูลสินค้า -->
                                        <v-row class="border-color-milk pa-4">
                                            <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="px-5">
                                                <div class="d-flex">รหัสสินค้า : {{ product_first.product_code }}</div>
                                            </v-col>
                                            <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="px-5">
                                                <div class="d-flex">ชื่อสินค้า : {{ product_first.name }}</div>
                                            </v-col>
                                            <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="px-5 pt-1 pb-4">
                                                <div class="d-flex">ชื่อทางการแพทย์ : {{ product_first.name_sci }}</div>
                                            </v-col>
                                            <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="px-5 pt-1 pb-4">
                                                <div class="d-flex">
                                                    ประเภทสินค้า : {{ product_first.types_name != null ?
                                                    product_first.types_name : '-' }}
                                                </div>
                                            </v-col>
                                        </v-row>


                                        <v-col cols="12" class="mt-5">
                                            <div class="d-flex">
                                                <div class="text-center">
                                                    <div class="content-header-title">ข้อมูลคลังสินค้าทุกสาขา</div>
                                                </div>
                                            </div>
                                        </v-col>
                                        
                                        <v-row class="border-color-milk">
                                            <v-col cols="12">
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    รหัสสาขา
                                                                </th>
                                                                <th class="text-left">
                                                                    ชื่อสาขา
                                                                </th>
                                                                <th class="text-left">
                                                                    จำนวนคงเหลือในคลัง
                                                                </th>
                                                                <th class="text-left">
                                                                    หน่วยนับ
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(branch, index) in data_list" :key="index">
                                                                <td>{{ branch.customer_code }}</td>
                                                                <td>{{ branch.name }}</td>
                                                                <td>{{ branch.total_unit ? branch.total_unit : '-' }}
                                                                </td>
                                                                <td>{{ branch.unit_name ? branch.unit_name : '-' }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>

                                    </v-row>
                                </v-form>
                            </div>
                        </v-card-text>
                    </v-card>
                </Transition>
            </v-col>

        </v-row>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Search_stock",
    data() {
        return {
            show: false,
            product_id: null,
            page: 1,
            size: 10,
            count_page: 1,
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'คลัง',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้าทุกสาขา',
                    disabled: false,
                    href: '#',
                },
            ],
            product_list: [],
            product_first: '',
            data_list: [],
            search: '',
            loading_page: false,
        }
    },
    methods: {
        displayText(item) {
            return `${item.product_name} (${item.lot_no}) - Exp. ${item.date_expired}`;
        },
        async getProductAll() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            console.log(config);

            await HTTP_ARIN.get('/warehouse/productall', config).then((res) => {
                if (res.data.successful === true) {
                    this.product_list = res.data.productList
                    this.loading_page = false;
                }
            })
        },

        async showBranch() {
            this.loading_page = true;
            this.data_list = [];
            const data = {
                product_code: this.product_id,
                page: this.page,
                size: this.size,

            };
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            await HTTP_ARIN.post('/warehouse/productgoodsalesbranchall', data, config).then((res) => {
                if (res.data.successful === true) {
                    this.data_list = res.data.BranchSaleList;
                    this.getProductFirst();
                    this.loading_page = false;
                    this.show = true;
                }
            })
        },
        filterProduct(item, queryText) {
            const name = (item.name || '').toLowerCase();
            const q = (queryText || '').toLowerCase();
            return name.includes(q);
        },

        async getProductFirst() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            console.log(config);

            await HTTP_ARIN.get('/warehouse/productfirst?product_code=' + this.product_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.product_first = res.data.ProductFirst
                    this.loading_page = false;
                }
            })
        },
        async exportToExcel() {
            if (!this.product_id) {
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                },
            };

            const payload = {
                product_code: this.product_id,
                page: 1,
                size: 10000,
            };

            try {
                const res = await HTTP_ARIN.post(
                    "/warehouse/productgoodsalesbranchall",
                    payload,
                    config
                );
                if (!res.data.successful) {
                    throw new Error("Fetch failed");
                }

                // ดึง data มาทั้งหมด
                // ถ้า backend คืนเป็น array ตรงๆ ใช้ res.data.BranchSaleList
                const allItems = res.data.BranchSaleList;

                // แปลงเป็น rawData
                const rawData = allItems.map((item, idx) => ({
                    'ลำดับ': idx + 1,
                    'รหัสสาขา': item.customer_code,
                    'ชื่อสาขา': item.name,
                    'จำนวนคงเหลือในคลัง': item.total_unit != null ? item.total_unit : "-",
                    'หน่วยนับ': item.unit_name || "-",
                }));

                // สร้าง sheet + workbook + ดาวน์โหลด
                const ws = XLSX.utils.json_to_sheet(rawData);
                // ตั้งความกว้างของคอลัมน์ (!cols)
                ws['!cols'] = [
                    { wch: 6 },   // ลำดับ
                    { wch: 15 },  // รหัสสาขา
                    { wch: 30 },  // ชื่อสาขา
                    { wch: 12 },  // จำนวนคงเหลือในคลัง
                    { wch: 10 },  // หน่วยนับ
                ];
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "คลังสินค้าทุกสาขา");

                const safeCode = String(this.product_id || "product").replace(/[^a-zA-Z0-9._-]/g, "_");
                const ds = new Date().toISOString().slice(0, 10);
                const filename = `warehouse_all_${safeCode}_${ds}.xlsx`;
                XLSX.writeFile(wb, filename);
            } catch (err) {
                console.error("Export failed:", err);
                this.alert_message_error = "ไม่สามารถส่งออกข้อมูลได้";
                this.alert_error = true;
                setTimeout(() => (this.alert_error = false), 5000);
            }
        },
    },
    mounted() {
        this.getProductAll();
    }

}
</script>

<style>
.btn_add_data {
    font-size: 16px;
    color: rgb(255, 255, 255) !important;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
}

.border-color-milk {
    border: 1px solid #D6BFAF;
    border-radius: 10px;
    margin: 0;
}

.content-header-title {
    color: #616A6B;
    font-weight: 1000;
    font-size: 22px;
}

.title_form_main {
    background: #D6BFAF;
    z-index: 2;
    border-radius: 50%;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
    height: 38px;
    left: calc(50% - 19px);
    width: 38px;
}

.logo_timeline {
    padding: 6px;
}


.logo_timeline>img {
    max-width: 25px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
    color: #616A6B;
    font-weight: 500;
    font-size: 16px;
}

label.label_form_text {
    font-size: 16px !important;
    color: #616A6B !important;
}

.input-radius {
    border-radius: 10px;
}

.title_page h4.breadcrumb_title_page {
    font-size: 20px !important;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}

@media only screen and (max-width: 600px) {

    .title_page h4.breadcrumb_title_page,
    .v-tab {
        font-size: 14px !important;
    }

    .v-timeline-item__divider {
        display: none !important;
    }

}
</style>